// Utils & misc
import cn from '../../../utils/cn';

// Components
import Picto from '../../atoms/Picto/Picto';

// Style
import style from './EventThumbnail.module.css';

/**
 * EventThumbnail component - Square thumbnail with add icon and label, or image if imageUrl is provided
 * @param {object} params
 * @param {string} params.label - Text label to display (when no image)
 * @param {string | null} [params.imageUrl] - Optional image URL to display
 * @param {string} [params.className] - Additional CSS classes
 * @param {(event: React.MouseEvent<HTMLButtonElement>) => void} [params.onClick] - Click handler
 * @returns {JSX.Element} EventThumbnail component
 */
function EventThumbnail({
  label,
  imageUrl = null,
  className,
  onClick,
}) {
  const hasImage = !!imageUrl;

  if (hasImage) {
    return (
      <div
        className={cn([
          style['event-thumbnail'],
          style['event-thumbnail-image'],
          className,
        ])}
        aria-label={`Image: ${label}`}
      >
        <img
          src={imageUrl}
          alt={label || 'Thumbnail'}
          className={style.image}
        />
      </div>
    );
  }

  return (
    <button
      type="button"
      className={cn([style['event-thumbnail'], className])}
      onClick={onClick}
      aria-label={`Créer un événement: ${label}`}
    >
      <div className={style.icon}>
        <Picto icon="add" />
      </div>
      <div className={style.label}>
        {label}
      </div>
    </button>
  );
}

export default EventThumbnail;
